const messages = {
  title: "Product information and approvals",
  description:
    "Welcome to the brochure and price list section for Bridgestone and Firestone products. Here you will find current brochures and price lists for all product areas as well as Pricat files for your merchandise management system.",
};
export default {
  messages,
};
